/**
 * Forma de error de los endpoints de ms-knowledge-py (contrato
 * INETUM2025-1491): `{errorId, code, message, detail}`. Distinta del
 * `{errorMessage,...}` de los micros Java — los servicios de conexiones,
 * Confluence, Azure Wiki e índice la parsean directamente.
 */
export interface ErrorResponse {
  errorId: string;
  /**
   * Código machine-readable para distinguir causas dentro de un mismo HTTP
   * status. Conjunto abierto; valores iniciales: URL_BLOCKED, PAT_INVALID,
   * PAT_SCOPE_INSUFFICIENT, CONNECTION_MISSING, PROVIDER_UNAVAILABLE.
   */
  code?: string | null;
  message: string;
  detail?: string | null;
}

/**
 * Extrae el ErrorResponse del error HTTP de Angular, si viene con esa forma.
 * Tolera el re-empaquetado del error.interceptor (`{error: HttpErrorResponse}`):
 * desciende por los `error` anidados hasta encontrar el body del contrato,
 * identificado por su `errorId` (un HttpErrorResponse también tiene `message`,
 * pero nunca `errorId`).
 */
export function extractErrorResponse(err: unknown): ErrorResponse | null {
  let body = (err as { error?: unknown })?.error;
  let depth = 0;
  while (body && typeof body === 'object' && depth < 3) {
    if ('errorId' in (body as object) && 'message' in (body as object)) {
      return body as ErrorResponse;
    }
    body = (body as { error?: unknown }).error;
    depth++;
  }
  return null;
}

/**
 * Devuelve el status HTTP del error, tanto si llega el HttpErrorResponse
 * crudo como si viene re-empaquetado por el error.interceptor.
 */
export function extractHttpStatus(err: unknown): number | undefined {
  const outer = err as { status?: number; error?: { status?: number } };
  return outer?.status ?? outer?.error?.status;
}
